import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";

export class Hotel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  render () {
    return (
      <div class="main">
        <Helmet>
          <title>Система бронирования для отелей | Онлайн-запись номеров — Planna</title>
          <meta name="description" content="Поэтажные планы с выбором конкретного номера. Гости видят реальные фото и доступность. Управление загрузкой, статусы уборки. Бесплатно для отелей." />
        </Helmet>
        <h1 class="main2">Выбор конкретного номера на поэтажном плане — как в самолёте, только лучше</h1>
        <h2 class="main2">Гости видят, какой номер выбирают, а вы — управляете загрузкой визуально</h2>
        <div class="main3">Как это работает:</div>
        <div class="main3">Вы загружаете поэтажные планы вашего отеля и выделяете номера на схеме. Каждый номер на плане — это интерактивный объект с полной информацией:</div>
        <div class="w40 main3">
        Что видит гость при бронировании:
        </div>
        <div class="w40 main3">
        Выбирает даты заезда и выезда, видит поэтажный план с доступными номерами, номера подсвечены цветом:
        </div>
        <div class="w40">
          <ul class="main3">
            <li>Свободен</li>
            <li>Забронирован</li>
            <li>Выбран для бронирования</li>
            <li>На уборке (скоро освободится)</li>
          </ul>
        </div>

        <div class="w40 main3">
        Может выбрать конкретный номер:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>С видом на море/город/сад</li>
            <li>Рядом с лифтом или в тихом конце коридора</li>
            <li>С определённой планировкой (например, с отдельной душевой кабиной вместо ванны)</li>
          </ul>
        </div>



        <div class="w40 main3">
        Что видит сотрудник на ресепшн:
        </div>

        <div class="w40 main3">
        Поэтажный план показывает загрузку отеля в реальном времени. Сотрудник сразу видит, какие номера свободны, какие скоро освободятся, а где гости ещё не выехали. Можно заселить гостя в конкретный номер за 30 секунд, даже если он приехал раньше расчётного часа — просто смотрю, где уже готова уборка
        </div>

        <div class="w40 main3">
        Для каждого номера настраивается:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>Категория (стандарт, полулюкс, люкс, семейный)</li>
            <li>Базовая цена и динамическое ценообразование</li>
            <li>Список удобств (Wi-Fi, кондиционер, мини-бар, вид из окна)</li>
            <li>Фотографии именно этого номера (не "типовой картинки")</li>
            <li>Варианты питания и стоимость</li>
            <li>Варианты отмены</li>
            <li>Дополнительные сборы</li>
            <li>Статус (чистый, грязный, на уборке, на ремонте)</li>
            <li>Ограничения (не заселять с животными, только некурящие)</li>
          </ul>
        </div>

        <div class="w40 main3">
        Гибкие правила бронирования:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>Минимальный срок проживания в высокий сезон и в дни недели</li>
            <li>Депозит или предоплата для определённых категорий</li>
            <li>Спецпредложения на конкретные номера</li>
            <li>Автоматическое апгрейд-предложение при загрузке</li>
          </ul>
        </div>

        <div class="w40 main3">
        Для хостелов и апарт-отелей выбор конкретного места:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>В многоместных номерах можно выбрать конкретную койку</li>
            <li>Видно, какие места уже заняты (анонимно, без имён)</li>
            <li>Можно забронировать всю комнату целиком для компании</li>
          </ul>
        </div>

        <div class="w40 main3">
        Например: путешественник видит схему 6-местного номера с подсветкой свободных мест. Он выбирает нижнюю койку у окна — именно ту, которая ему нравится. Администратор видит ту же схему и знает, что место 3А занято, а 3В и 3С свободны
        </div>

        <div class="w40 main3">
        Преимущества:
        </div>

        <div class="main3 w40"><table style={{textAlign: "left"}} class="table table-striped">
          <thead><tr><th>Для отеля</th><th>Для гостя</th></tr></thead>
          <tbody>
            <tr>
            <td>Максимальное заполнение номерного фонда</td><td>Выбор конкретного номера, а не "кота в мешке"</td>
            </tr><tr>
            <td>Никаких двойных бронирований</td><td>Уверенность, что номер с нужным видом будет</td>
            </tr><tr>
            <td>Визуальный контроль уборки и статусов</td><td>Прозрачность — видно, какие номера свободны</td>
            </tr><tr>
            <td>Быстрое заселение без очередей</td><td>Возможность выбрать этаж и расположение</td>
            </tr><tr>
            <td>Аналитика загрузки по категориям и этажам</td><td>Легкое бронирование с телефона</td>
            </tr>
          </tbody></table>

        <div class="w40 main3">
          Для гостей, которые привыкли к особенному сервису, мы добавили функцию "Мой любимый номер". Система запоминает, какой номер гость выбирал в прошлый раз, и предлагает его при повторном бронировании. А если номер занят — показывает максимально похожий по параметрам
        </div>

        </div>

        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (номера)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
      </div>
    );
  }
}
